<template>
  <div class="final_center">
    <img
      src="../../assets/banner_2025.jpg"
      alt=""
      style="width: 100%; margin-bottom: 50px;margin-top: 50px"
    />
    <h1 class="title_second">2025“敦煌杯”(北美赛区)获奖名单正式揭晓</h1>
    <div class="constitution">
      <p style="margin-bottom: 24px"></p>
      <div class="key_point">
        <span class="bc_red">民族音色亮相国际艺术节，多元文化交融共鸣</span>
        <br />
        <p class="content">
          作为加拿大国际多元文化艺术节的重要活动之一，2025“敦煌杯”（北美赛区）不仅展示中华民族音乐艺术在世界舞台上的专业水准，也将成为促进中加文化交流、拓展国际艺术视野的重要桥梁。赛事将与艺术节同步开展文化体验活动、专题讲座、公开演出等，推动民众更深入理解中华音乐文化，促进不同族裔群体之间的艺术互动与共融。
        </p>
      </div>
      <div class="key_point">
        <span class="bc_red">跨越国界的音律，国际赛事标准全面升级</span>
        <br />
        <p class="content">
        北美赛区将在传承权威赛事体系的基础上，对接国际顶级音乐比赛标准，结合北美音乐教育特色，建立公平公开、专业细致的评审体系，提升中华民族乐器在世界音乐教育体系中的影响力。赛事吸引了包括加拿大，美国，南非等国的多名选手参加，旨在为音乐学习者与专业演奏者提供高规格国际舞台，助力中华民族音乐在世界范围内的传播与发展。
        </p>
      </div>
      <div class="key_point">
        <span class="bc_red">“敦煌杯”国际影响力持续扩大</span>
        <br />
        <p class="content">
        自2010年创办以来，“敦煌杯中国民族器乐系列艺术菁英展演、比赛活动”凭借国际专家评审团队、严谨规范赛制与深度艺术交流，成为中国民族音乐领域具有国际声望的品牌赛事。其国际影响力不断拓展，目前已先后在日本、新加坡建立独立运营的国际赛区，广受全球音乐界、教育界与华人文化群体认可。
        </p>
      </div>
      <div class="key_point">
        <span class="bc_red">“文化自信走向世界，艺术节助力多元共荣</span>
        <br />
        <p class="content">
        北美赛区多乐器项目的设立，是中华民族音乐在国际艺术节平台上的重要呈现，也将促进更广泛的文化合作、教育共建与艺术交流。通过此次艺术节舞台，“敦煌杯”将进一步推动中华民族音乐在全球范围内的多元传播、国际对话与文化自信表达，让世界听见中华民族的声音，理解中华艺术，欣赏中华美学。
        </p>
        <img src="../../assets/h1.jpg" alt="" class="img-30" />
        <img src="../../assets/h2.jpg" alt="" class="img-30" />
      </div>
      <div class="key_point">
        <span class="bc_red">2025“敦煌杯”中国器乐演奏比赛（北美赛区）评委名单（按笔画顺序）：</span>
          <br />
        名誉主席：刘长福
          <br />
        主席：杨忠才
          <br>
        弦乐组评委：田再励、白雪、刘扬、李扬、陈国产、陈洁冰、周佳莉、梁云河
          <br />
        弹拨组评委：于志敏、尤卉、刘桂莲、张丹卉、何晓梅、陈文英、陈善志、南飞鸿、高虹、曹丽娜、韩梅、管亚东、谭宇莎
          <br />
        吹管组评委：杨忠才、南飞鸿、陳姿珺、陈洁冰、刘扬
          <br />
        合奏组评委：于志敏、刘桂莲、何晓梅、陈文英、高虹、陳姿珺
          <br />
      </div>
      <div class="key_point">
    <img src="../../assets/ss1.jpg" alt="" class="img-30" />
    <img src="../../assets/ss2.jpg" alt="" class="img-30" />
    <img src="../../assets/ss3.jpg" alt="" class="img-30" />
    <img src="../../assets/ss4.jpg" alt="" class="img-30" />
    <img src="../../assets/ss5.jpg" alt="" class="img-30" />
    <img src="../../assets/ss6.jpg" alt="" class="img-30" />
    <img src="../../assets/ss7.jpg" alt="" class="img-30" />
    <img src="../../assets/ss8.jpg" alt="" class="img-30" />
      </div>

      <div class="key_point">
        <br />
        在这个充满喜悦和激动的时刻，我们怀着无比的感激和喜悦，向每一位参与了大赛的您表示最诚挚的谢意！正是因为您的热情、才华和付出，才使得这场竞赛充满了如此令人惊叹的创意和成就。
        <br />
        感谢所有的参赛者，你们的热情投入和无私分享，让这场比赛成为了一个真正的知识交流与启发的平台。你们的激情和才华，构建了一个令人难以忘怀的比赛记忆。
        <br />
        恭喜获奖者们在激烈的竞争中脱颖而出，以卓越的表现赢得了金、银、铜奖项。你们的辛勤努力和创新精神不仅仅为您们赢得了荣誉，更是为整个大赛增添了无限的光彩。
        <br />
        同时，我们还要向评审团成员表示由衷的感谢。你们的专业眼光和公正评价，为获奖名单的产生提供了有力的支持。你们的辛勤工作，为比赛的公正性和权威性保驾护航。
        <br />
        最后，感谢所有支持本次比赛的合作伙伴、赞助商和观众朋友们。是你们的支持，让这个比赛得以顺利举行，并在广大人们中传播着创新和激情的火花。
        <br />
        让我们共同庆祝这个难以忘怀的时刻，愿未来的日子里，我们仍然保持着对知识和创新的热情，携手共创更加美好的明天！
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data(){
      return{
          show_paycode2: false,
          show_paycode4: false,
      }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  margin: 0;
  padding: 0;
}
p {
  text-indent: 2em;
  text-align: justify;
  margin: 4px 0;
  line-height: 30px;
}
pre {
  font-size: 16px;
}
.final_center {
  width: 70%;
  margin: 0 auto;
}
.title_first {
  font-size: 28px;
  color: #c0504d;
  text-align: center;
}
.title_second {
  font-size: 22px;
  color: #c0504d;
  text-align: center;
}
.constitution {
  width: 95%;
  margin: 0 auto;
}
.key_point {
  margin: 30px 0;
  text-align: justify;
  line-height: 30px;
}
.key_point span {
  display: inline-block;
}
.key_point img {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.key_point .bc_red {
  display: inline-block;
  font-size: 18px;
  background-color: #c0504d;
  color: white;
  margin-bottom: 3px;
  font-weight: bold;
}
.key_point .bold {
  font-weight: bold;
}
.key_point .small {
  font-size: 12px;
}
.key_point .ban {
  color: #ccc;
}
.key_point .red {
  color: #c0504d;
  font-weight: bold;
}
.key_point .center {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}
.key_point .content {
  text-indent: 0;
  margin-top: 0;
}
.key_point .register_entry {
  width: 200px;
  position: fixed;
  bottom: 0;
  left: 100%;
  transform: translateX(-100%);
  z-index: 2;
}
.clickToGoIn {
  font-size: 26px;
  color: red;
  font-weight: bold;
}
.img-30 {
  display: block;
  width: auto;
  max-width: 80%;
  margin: 30px 0 30px 0;
}
</style>
